'use strict';

var luxon = require('luxon');

const subtractFromDate = (date, amount, format)=>{
    const copy = luxon.DateTime.fromJSDate(new Date(date));
    switch(format){
        case 'months':
            return copy.minus({
                months: amount
            }).toJSDate();
        case 'weeks':
            return copy.minus({
                weeks: amount
            }).toJSDate();
        case 'days':
            return copy.minus({
                days: amount
            }).toJSDate();
    }
};
/**
 * This function takes a Luxon DateObjectUnits representing either a specific date, or just a time of day, as well as a from timezone.
 * It returns a javascript date object with the correct time of day in target timezone.
 */ const createDateInTimezone = ({ time, zone })=>{
    // Create a DateTime object for today at chosen time in chosen timezone
    const chosenZoneTime = luxon.DateTime.now().setZone(zone).set(time);
    return chosenZoneTime.toJSDate();
};
/**
 * This function takes a date and returns a Luxon DateTime object.
 */ const toLuxonDateTime = (date)=>{
    return luxon.DateTime.fromJSDate(new Date(date));
};

exports.createDateInTimezone = createDateInTimezone;
exports.subtractFromDate = subtractFromDate;
exports.toLuxonDateTime = toLuxonDateTime;
//# sourceMappingURL=index.js.map
